import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { FlameIcon } from "lucide-react";
import { SCARCITY } from "../data/offer";
export function ScarcityBar() {
  const reduce = useReducedMotion();
  return <div className="mt-6 rounded-xl border border-red-200 bg-red-50 p-4" data-id="element-208" data-mp="2l44vukx1cxgt">
      <p className="flex items-center justify-center gap-2 text-center text-[15px] font-bold text-red-800" data-id="element-209" data-mp="2q37of5vtxb7w">
        <FlameIcon className="h-5 w-5 shrink-0" aria-hidden data-id="element-210" data-mp="2b5p20a6mja3m" />
        Only {SCARCITY.spotsLeft} spots left at the promotional price
      </p>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-red-100" role="progressbar" aria-valuenow={SCARCITY.filledPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-211" data-mp="2g3qjiqoej1cz">
        <motion.div className="h-full rounded-full bg-red-600" initial={reduce ? false : {
        width: "0%"
      }} whileInView={{
        width: `${SCARCITY.filledPercent}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.1,
        ease: [0.23, 1, 0.32, 1]
      }} style={reduce ? {
        width: `${SCARCITY.filledPercent}%`
      } : undefined} data-id="element-212" data-mp="g09zt300mjv" />
      </div>
      <p className="mt-2 text-center text-xs font-semibold text-red-800/80" data-id="element-213" data-mp="3dbmy4prwzrfl">
        {SCARCITY.filledPercent}% of promotional spots already claimed
      </p>
    </div>;
}